import { render, staticRenderFns } from "./today-lotto-any.vue?vue&type=template&id=55d2be6d&"
import script from "./today-lotto-any.vue?vue&type=script&lang=js&"
export * from "./today-lotto-any.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports